(function (window) {
   'use strict';
   var app = window.app = window.app || {};
   
   // APP NAME
   app.modules = {
      app: {
         name: "GRPApp"
         , controller : "GRPAppController"
      }
   };
}(window));